var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.399,
    height: 22.399,
    viewBox: "0 0 22.399 22.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.529 -0.529)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.7.529A2.252,2.252,0,0,0,15.519,2.28L7.072,6.5H5.755a5.222,5.222,0,0,0-2.239,9.942v5.737a.747.747,0,0,0,.748.746H7.248a.747.747,0,0,0,.746-.746V17.417l7.525,3.763a2.238,2.238,0,0,0,4.422-.492v-5.3a3.732,3.732,0,0,0,0-7.314V2.77A2.253,2.253,0,0,0,17.7.529Zm0,1.494a.73.73,0,0,1,.748.746V20.688a.747.747,0,0,1-1.494,0V2.77A.729.729,0,0,1,17.7,2.023ZM15.464,3.976V19.481L8,15.748V7.711ZM5.755,8H6.5v7.467H5.755A3.733,3.733,0,0,1,5.755,8ZM19.943,9.638a2.21,2.21,0,0,1,0,4.181ZM5.01,16.9a5.2,5.2,0,0,0,.745.059H6.5v4.478H5.01Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphoneWhite);
export default __webpack_public_path__ + "static/media/megaphone-white.925b9681841ef634ca7125d77584f82d.svg";
export { ForwardRef as ReactComponent };